import { render } from "./CustomizationGlobalDialogs.vue?vue&type=template&id=e6eb11a2"
import script from "./CustomizationGlobalDialogs.vue?vue&type=script&lang=js"
export * from "./CustomizationGlobalDialogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__